document.addEventListener("DOMContentLoaded", function() {
    var toggleElements = document.querySelectorAll('.colllection__cartButton-container [data-toggle-button]:not(.disabled)');

    toggleElements.forEach(function(element) {
        element.addEventListener('click', function() {
            var form = element.closest('.colllection__cartButton-container').querySelector('.colllection__cartButton');

            if (form.style.display === "none" || form.style.display === "") {
                form.style.display = "block";
                element.classList.add('rotated');
            } else {
                form.style.display = "none";
                element.classList.remove('rotated');
            }
        });
    });
});

$(document).ready(function(){
    // Slider for .pro
    $('.slider.pro').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '',
        nextArrow: '',
        dots: true,
        fade: true,
        cssEase: 'linear'
    });

    // Slider for .top
    var $sliderTop = $('.slider.top');  // キャッシュ
    $sliderTop.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 3000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '',
        nextArrow: '',
        dots: true,
        fade: true,
        cssEase: 'linear'
    });

    $sliderTop.find('.slick-dots button').on('click', function() {
        var slideIndex = $(this).parent().index();
        $sliderTop.slick('slickGoTo', slideIndex);
    });

    var slideCount = $sliderTop.find(".slide").length;
    var dotWidth = (300 - (slideCount - 1) * 8) / slideCount;
    $sliderTop.find(".slick-dots li").css("width", dotWidth + "px");

    // Block link
    $('.block_link').css('cursor','pointer').on('click', function() {
        window.location.href = $(this).find('a').attr('href');
    });
});



  // DOMが読み込まれた後に実行される関数を設定
  document.addEventListener('DOMContentLoaded', function() {
    // 'product-option'クラスを持つ全ての要素を取得
    var elements = document.querySelectorAll('.product-option');

    // 各要素に対してループ処理
    elements.forEach(function(element) {
      // 要素のテキストが'Pre-order Today'に一致するか確認
      if (element.textContent.trim() === 'Pre-order Today') {
        // 一致する場合は要素を非表示にする
        element.style.display = 'none';
      }
    });
  });
